// src/components/Dashboard.js
import React from 'react';
import PaymentLogs from '../components/Tables/PaymentLogs ';

const Payments = () => {
  return (
    <div className="p-5">
      <PaymentLogs />
    </div>
  );
};

export default Payments;
